import "./teaching.css";
import { Link } from "react-router-dom";

const courses = [
    {
        title: "COS 435/ECE 433: Introduction to Reinforcement Learning (Spring 2026)",
        shortDescription: "An introductory course covering fundamental RL concepts, key algorithms like Q-learning and policy gradients, and applications to robotics, healthcare, and molecular science.",
        image: require("./course_images/da113242-14df-4074-96b6-545b0a6b3495.png"),
        link: "cos435-rl/index.html"
    },
    {
        title: "COS 598A: AI Safety & Alignment (Princeton)",
        shortDescription: "An advanced seminar exploring AI safety risks, mitigation strategies, and alignment methods. Topics include reinforcement learning, sociotechnical AI safety, and governance.",
        image: require("./course_images/da113242-14df-4074-96b6-545b0a6b3495.png"),
        link: "https://princeton-polaris-lab.github.io/ai-safety-course/"
    },
    {
        title: "SPI 352/COS 352: Artificial Intelligence, Law, & Public Policy (Fall 2024)",
        shortDescription: "Interdisciplinary course examining AI's impact on law and public policy, covering IP law, administrative law, anti-discrimination law, and emerging regulatory frameworks.",
        image: require("./course_images/f82502cb-bf11-43cf-95a0-06bff430221f.png"),
        link: "https://princeton-polaris-lab.github.io/ailaw/"
    },
    {
        title: "SPI 352/COS 352: Artificial Intelligence, Law, & Public Policy (Fall 2025)",
        shortDescription: "Updated version of the interdisciplinary AI law course for Fall 2025, examining AI's evolving impact on law and public policy with current case studies and regulatory developments.",
        image: require("./course_images/f82502cb-bf11-43cf-95a0-06bff430221f.png"),
        link: "ai-law-2025/index.html"
    },
    {
        title: "CS 384: Ethical and Social Issues in Natural Language Processing (Stanford)",
        shortDescription: "Advanced NLP seminar covering ethical and social issues in large language models, research ethics, data practices, harm mitigation, and applications to social justice questions.",
        image: require("./course_images/stanford_university_main_quad.jpg"),
        link: "https://web.stanford.edu/class/cs384/"
    }
];

export default function Teaching() {
    return (
        <div className="teaching-page">
            <div className="teaching-header">
                <h1>Teaching</h1>
                <p className="teaching-subtitle">
                    Check out some of our course offerings!
                </p>
            </div>
            
            <div className="courses-grid">
                {courses.map((course, index) => (
                    <div className="course-card" key={index}>
                        <div className="course-image-container">
                            <img src={course.image} alt={course.title} className="course-image" />
                            <div className="course-image-overlay"></div>
                        </div>
                        <div className="course-content">
                            <h2 className="course-title">{course.title}</h2>
                            <p className="course-description">{course.shortDescription}</p>
                            <div className="course-actions">
                                {course.link.startsWith('http') || course.link.includes('.html') ? (
                                    <a 
                                        href={course.link} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="course-button primary"
                                    >
                                        View Course
                                    </a>
                                ) : (
                                    <Link 
                                        to={course.link} 
                                        className="course-button primary"
                                    >
                                        View Course
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
} 